// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-37ac5120] .page-pageination {\n  text-align: right;\n  padding-top: 10px;\n}\n[data-v-37ac5120] .page-pageination .el-input {\n  display: inline-block !important;\n}\n", ""]);
// Exports
module.exports = exports;
